import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Page from "../components/Page"
import CoverImage from "../screens/FolioPage/CoverImage"
// import FolioArea from "../screens/FolioPage/FolioArea"
import FooterArea from "../screens/FolioPage/FooterArea"
//""
import SEO from "../components/SEO"
const AboutUs: React.FC<{}> = function (props) {
  const { allContentfulFolioLaunch } = useStaticQuery(graphql`
    query IssuLinkFolioContent {
      allContentfulFolioLaunch {
        edges {
          node {
            issuEmbedLink
          }
        }
      }
    }
  `)

  const firstNode = allContentfulFolioLaunch.edges[0]
  return (
    <Page contactUsVisibility="hide">
      <SEO title="Folio Page" />
      <CoverImage />
      {/* <FolioArea /> */}
      <iframe
        allowFullScreen={true}
        style={{ border: "none", width: "100%", height: "326px" }}
        src={firstNode.node.issuEmbedLink}
      ></iframe>
      <FooterArea />
    </Page>
  )
}

export default AboutUs
